import { toast } from "react-toastify";

interface AxiosErrorLike {
  response?: {
    data?: {
      error?: string;
      message?: string;
    };
  };
}

/**
 * Trata erros de API de forma centralizada
 * Exibe toast com mensagem apropriada
 */
export const handleApiError = (
  error: unknown,
  fallbackMessage: string
): void => {
  let message = fallbackMessage;

  if (error && typeof error === "object" && "response" in error) {
    const axiosError = error as AxiosErrorLike;
    message =
      axiosError.response?.data?.error ||
      axiosError.response?.data?.message ||
      fallbackMessage;
  } else if (error instanceof Error && error.message) {
    message = error.message;
  }

  toast.error(message);
};

/**
 * Extrai mensagem de erro de uma resposta de API
 * Útil quando você precisa da mensagem mas não quer exibir toast
 */
export const getApiErrorMessage = (
  error: unknown,
  fallbackMessage: string
): string => {
  if (error && typeof error === "object" && "response" in error) {
    const axiosError = error as AxiosErrorLike;
    return (
      axiosError.response?.data?.error ||
      axiosError.response?.data?.message ||
      fallbackMessage
    );
  }

  if (error instanceof Error && error.message) {
    return error.message;
  }

  return fallbackMessage;
};
